import { render, staticRenderFns } from "./SetupContactChannels.vue?vue&type=template&id=1dda8565&"
import script from "./SetupContactChannels.vue?vue&type=script&lang=js&"
export * from "./SetupContactChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports